import { OccConfig } from '@spartacus/core';

export const returnsOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        getReturns: '/users/${userId}/returns/search',
        getOrder: '/users/current/orders/details?uid=${uid}',
        exportDetailsOrder: '/users/current/orders/details/export?uid=${uid}',
        getReturnsExport: '/users/current/returns/export',
      } as any,
    },
  },
};
